/**
 * Supabase OAuth 2.1 consent — reading what `getAuthorizationDetails` answered.
 *
 * Consent already given: the server approves the request on the spot and answers
 * `{ redirect_url }` — the client's callback WITH its code and state, to follow at once.
 * Otherwise: the details to show on the consent screen.
 *
 * Not to be confused with `details.redirect_uri`, the client's registered callback without a
 * code: following it broke the token exchange (22/04/2026, « code: Field required »).
 */
export function consentRedirectUrl(answer: unknown): string | null {
  if (typeof answer !== 'object' || answer === null || !('redirect_url' in answer)) return null;
  const url = answer.redirect_url;
  return typeof url === 'string' && url.length > 0 ? url : null;
}
